/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-19 13:19:05
 * @FilePath: /unifyxp-v2-store-portal/src/components/ImageDraggableDisplay/index.tsx
 */
/**
 *  Product Draggable
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';

import css from './css.module.less';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import DragNDropColumns from 'src/components/DragNDropColumns';
import DraggableImageDisplay from 'src/components/DragRowDisplay/Image';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ImgDraggableDisplay = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    droppableId,
    data,
    onChange,
    onSort,
    onDelete,
    hideAdd,
    onAdd,
    addText,
    disabled,
    hideEdit,
  } = props;

  const _onDelete = (index, E) => {
    if (onDelete) {
      onDelete(index, E);
    }
  };

  const childGenerate = (data, index) => {
    const { linkImage, imgErr } = data || {};
    // console.log({ uuid, linkType, label, action });
    return (
      <Section className={css.section}>
        <DraggableImageDisplay
          error={imgErr}
          title={`${getI18n('general.checkImgDraggableDisplay.title')} ${
            index + 1
          }`}
          subtitle={getI18n('general.tiprecommendedsize')}
          onDelete={(e) => {
            _onDelete(index, e);
          }}
          imgOnChange={(img) => {
            if (onChange) {
              onChange(index, { linkImage: img });
            }
          }}
          linkImage={linkImage}
          disabled={disabled}
          hideEdit={hideEdit}
        />
      </Section>
    );
  };

  const _onSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    if (onSort) onSort(oldIndex, newIndex);
  };

  return (
    <React.Fragment>
      <DragNDropColumns
        hideTitle
        childGenerate={childGenerate}
        data={data}
        droppableId={droppableId}
        onSort={_onSort}
        hideAdd={hideAdd || disabled}
        onAdd={onAdd}
        addText={addText}
        hideDrag={disabled}
      />
    </React.Fragment>
  );
};
export default ImgDraggableDisplay;
